import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import moment from "moment";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

export default class RozliczeniaKierowcowSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            kierowca: null,
            czyRozliczoneArray:[{value:null,label:'wszystko'},{value:false,label:'nie'},{value:true,label:'tak'}],
            czyRozliczone: {value:null,label:'wszystko'},
            kurs:'',
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onChangeCzyRozliczone = this.onChangeCzyRozliczone.bind(this)
        this.onChangeKurs = this.onChangeKurs.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    renderKierowcaSelect(option) {
        return <div>
            <span>{option.imieNazwisko}</span>
            <div className={'pull-right'}>
                {
                    (option.status == 1) ?
                        <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                        :
                        <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> zajęty</span>
                }
            </div>
        </div>
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
    }

    onChangeKurs(e){
        this.setState({kurs:e.target.value})
    }

    onChangeCzyRozliczone(e){
        this.setState({czyRozliczone:e})
    }

    onClickSzukaj() {
        this.setState({czyByloSzukanie: false})
        if (DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd) > DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)) {
            alert('Data do nie może być wcześniejsza od daty od')
        } else {

            let params = {
                "dataDo": Boolean(this.state.dataDo)?DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo):'',
                "dataOd": Boolean(this.state.dataOd)?DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd):'',
                "idKi": (Boolean(this.state.kierowca)) ? this.state.kierowca.idKi : null,
                "idKu": this.state.kurs,
                "czyRozliczone": this.state.czyRozliczone.value,
            }
            this.props.handleClickSzukaj(params)
        }
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={2}>
                            <ControlLabel>Data od</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Data do</ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Kierowca</ControlLabel>
                            <TopSelect onChange={this.onChangeKierowca} value={this.state.kierowca} options={this.props.kierowcy}
                                       labelKey={'imieNazwisko'}
                                       valueKey={'idKi'} valueRenderer={this.renderKierowcaSelect} optionRenderer={this.renderKierowcaSelect}/>
                        </Col>
                        <Col xs={1}>
                            <ControlLabel>Numer kursu</ControlLabel>
                            <FormControl type={'number'} onChange={this.onChangeKurs}/>
                        </Col>
                        <Col xs={1}>
                            <ControlLabel>Czy rozliczone?</ControlLabel>
                            <TopSelect onChange={this.onChangeCzyRozliczone} value={this.state.czyRozliczone} options={this.state.czyRozliczoneArray} clearable={false}/>
                        </Col>
                        <Col xs={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction btnColor={'primary'} iconType={'fa fa-search'} text={'Szukaj'} onClick={this.onClickSzukaj}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczeniaKierowcow/components/RozliczeniaKierowcowSearchbox.js